const headerSearchBtn = document.getElementById('headerSearchBtn');
const headerSearch = document.getElementById('headerSearch');
let searchInput = headerSearch.querySelector('input[type="search"]');
const submit = headerSearch.querySelector('input[type="submit"]');


//клик по кнопке поиск - выезжает строка поиска
headerSearchBtn.addEventListener('click', () => {

	headerSearch.classList.toggle('open');
	searchInput.value = ''; //очистить строку поиска
	setTimeout(function() {
		searchInput.focus();
	}, 100);
})
//клик по кнопке поиск в строке -  строка поиска прячется
submit.addEventListener('click', (e) => {
	searchInput.value = searchInput.value.trim(); //удалить пробелы

	//при пустом запросе ничего не делать
	if(searchInput.value.length == 0) {
		e.preventDefault()
		return
	}
	headerSearch.classList.remove('open');
}) 

//выпадающий список для поля поиска
/* $('.search input[name=searchMain]').on('click', () => {
	$('.search #foundMain').css('opacity', '1');
	$('.search #foundMain').css('visibility', 'visible');
})  */



